import { createFileRoute } from '@tanstack/react-router';
import LoginTemplate from '@/features/agent/account/templates/LoginTemplate';

export const Route = createFileRoute('/account/login')({
  component: LoginPage,
});

function LoginPage() {
  return <LoginTemplate />;
}
